module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mine"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mine-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.userIcon,
      "id": "mine-header-userIcon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mine-header-userContent"
  }, [_c('div', {
    staticClass: "mine-header-userName"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "mine-header-userLocation"
  }, [(_vm.locationName.length > 2) ? _c('img', {
    staticClass: "mine-header-locationImg",
    attrs: {
      "src": require("../../../assets/icon/location.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mine-header-userLocationName"
  }, [_vm._v(_vm._s(_vm.locationName))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mine-content"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/userAccountSet"
    }
  }, [_c('div', {
    staticClass: "mine-content-cell mine-content-cell1"
  }, [_c('div', {
    staticClass: "mine-content-title"
  }, [_vm._v("账号设置")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/orderManager/0"
    }
  }, [_c('div', {
    staticClass: "mine-content-cell mine-content-cell2"
  }, [_c('div', {
    staticClass: "mine-content-title"
  }, [_vm._v("我的订单")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/addressList',
        query: {
          url: '/mine'
        }
      }
    }
  }, [_c('div', {
    staticClass: "mine-content-cell mine-content-cell3"
  }, [_c('div', {
    staticClass: "mine-content-title"
  }, [_vm._v("收货地址")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/mine/myBill"
    }
  }, [_c('div', {
    staticClass: "mine-content-cell mine-content-cell4"
  }, [_c('div', {
    staticClass: "mine-content-title"
  }, [_vm._v("我的发票")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aboutBlissMall"
    }
  }, [_c('div', {
    staticClass: "mine-content-cell mine-content-cell5"
  }, [_c('div', {
    staticClass: "mine-content-title"
  }, [_vm._v("关于我们")])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-458498f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mine/mine/mine.vue
// module id = 566
// module chunks = 1